import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiReportService } from '@providers/api/report/report.service';
import { UserProfile } from '@providers/api/user/user.data.interface';
import {
  BaseResponseBody,
  GETBaseResponseBody,
  GetUserProfileDetailsQueryParams
} from '@providers/api/user/user.request.interface';
import { UserAPIService } from '@providers/api/user/user.service';
import { QuestionnaireTenxSubmitPayload } from './tenx.interface';

/**
 * Questionnaire Tenx Service.
 *
 * @exports
 * @class QuestionnaireTenxService
 */
@Injectable()
export class QuestionnaireTenxService extends ApiReportService {
  private readonly userService = inject(UserAPIService);

  /**
   * Fetch user profile.
   *
   * @returns {Observable<GETBaseResponseBody<Array<UserProfile>>>}
   * @memberof QuestionnaireTenxService
   */
  fetchUserProfile(): Observable<GETBaseResponseBody<Array<UserProfile>>> {
    const params: GetUserProfileDetailsQueryParams = {
      limit: 1,
      withCount: false,
      include: [
        'allergy',
        'information',
        'medical',
        'medication',
        'user-lifestyle',
        'historical-last-state-update',
        'user-lifestyle'
      ]
    };
    return this.userService.get<GETBaseResponseBody<Array<UserProfile>>>(
      'user-profiles',
      params
    );
  }

  /**
   * Submit questionnaire.
   *
   * @param {QuestionnaireTenxSubmitPayload} body Payload.
   * @returns {Observable<BaseResponseBody<unknown>>}
   * @memberof QuestionnaireTenxService
   */
  submit(
    body: QuestionnaireTenxSubmitPayload
  ): Observable<BaseResponseBody<unknown>> {
    const endpoint = 'questionnaire/v2/submit-ten-x';
    return this.post<BaseResponseBody<unknown>>(endpoint, body);
  }
}
